(() => {
  if (customElements.get("ff-price-filter")) {
    return;
  }

  class FiftyFlowersPriceFilter extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll(".ff-button");
      this.maxPrice = 0;
      this.minPrice = 0;
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClick);
      this.observeMaxPriceInput();
    }

    handleClick = (event) => {
      event.preventDefault();
      this.buttons.forEach(button => {
        button.setAttribute("aria-pressed", "false");
        button.classList.remove("active");
      });
      const button = event.target.closest(".ff-button");
      if (button) {
        button.setAttribute("aria-pressed", "true");
        this.setPriceFilter(button);
        this.toggleButton(button);
      }
    };

    setPriceFilter(button) {
      const min = parseFloat(button.getAttribute("min"));
      const max = parseFloat(button.getAttribute("max"));
      
      if (isNaN(min) || isNaN(max)) {
        throw new Error('Invalid price range values');
      }
    
      const url = new URL(window.location.href);
      const priceFilter = `productsFilter:ss_price:${min}:${max}`;
    
      if (url.hash) {
        if (url.hash.includes('productsFilter:ss_price:')) {
          url.hash = url.hash.replace(/productsFilter:ss_price:[^/]+/, priceFilter);
        } else {
          url.hash += `/${priceFilter}`;
        }
      } else {
        url.hash = `#/${priceFilter}`;
      }
      window.location.href = url.toString();
    }

    toggleButton(clickedButton) {
      this.buttons.forEach((button) => {
        button.classList.remove("active");
      });

      clickedButton.classList.add("active");

      this.dispatchEvent(
        new CustomEvent("pricefilterchange", {
          bubbles: true,
        })
      );
    }

    observeMaxPriceInput() {
      const searchspringSidebar = document.querySelector(
        "#searchspring-sidebar"
      );

      if (searchspringSidebar) {
        const observer = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (mutation.type === "childList" || mutation.type === "subtree") {
              this.checkForPriceChange(searchspringSidebar);
            }
          }
        });

        observer.observe(searchspringSidebar, {
          childList: true,
          subtree: true,
        });

        this.checkForPriceChange(searchspringSidebar);
      }
    }

    checkForPriceChange(sidebarElement) {
      const maxssPriceElement = sidebarElement.querySelector("#maxss_price");
      const minssPriceElement = sidebarElement.querySelector("#minss_price");
      if (maxssPriceElement) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === "attributes") {
              if (mutation.attributeName == "min" || mutation.attributeName == "max") {
                this.setFilterButtonVisibility(minssPriceElement, maxssPriceElement);
              }
            }
          });
        });
        observer.observe(maxssPriceElement, {
          attributes: true,
        });
        this.setFilterButtonVisibility(minssPriceElement, maxssPriceElement);
        return true;
      }
    }

    setFilterButtonVisibility(minssPriceElement, maxssPriceElement) {
      this.maxPrice = parseFloat(minssPriceElement.getAttribute("max"));
      this.minPrice = parseFloat(maxssPriceElement.getAttribute("min"));
      const url = new URL(window.location.href);
      if (!url.hash.includes('productsFilter:ss_price:')) {
        this.buttons.forEach(button => {
          button.setAttribute("aria-pressed", "false");
          button.classList.remove("active");
        });
      }
      this.buttons.forEach((button) => {
        const max = parseFloat(button.getAttribute("max"));
        const min = parseFloat(button.getAttribute("min"));
        const isVisible = (this.minPrice >= min && this.minPrice <= max) || 
                      (this.maxPrice >= min && this.maxPrice <= max) ||
                      (this.minPrice <= min && this.maxPrice >= max);
        if (isVisible) {
          button.classList.remove("hidden");
        } else {
          button.classList.add("hidden");
        }
      });
    }
  }

  customElements.define("ff-price-filter", FiftyFlowersPriceFilter);
})();
